import React from "react";
import { Link } from "react-router-dom";
import { ellipsis, vertical } from "@heroicons/react/solid";
export default function ContactMails() {
  return (
    <div>
      <div className="container mx-auto w-fit  flex justify-center items-center bg-amber-400/70 rounded-md m-10 ">
        <div className="  m-10 ">
          {/*1*/}
          <div className="flex items-center  mb-4 shadow-md w-64 p-2 bg-white rounded-md">
            <div>
              <img
                src="https://source.unsplash.com/ZHvM3XIOHoE/400x400"
                alt="img"
                className="h-16 w-16 rounded-full"
              />
            </div>
            <div className="ml-5">Ali sardar</div>
            <div className="ml-10">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
                />
              </svg>
            </div>
          </div>
          {/*2*/}
          <div className="flex items-center  mb-4 shadow-md w-64 p-2 bg-white rounded-md">
            <div>
              <img
                src="https://source.unsplash.com/mjRwhvqEC0U/400x400"
                alt="img"
                className="h-16 w-16 rounded-full"
              />
            </div>
            <div className="ml-5">ara salam</div>
            <div className="ml-10">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
                />
              </svg>
            </div>
          </div>
          {/*3*/}
          <div className="flex items-center  mb-4 shadow-md w-64 p-2 bg-white rounded-md">
            <div>
              <img
                src="https://source.unsplash.com/rDEOVtE7vOs/400x400"
                alt="img"
                className="h-16 w-16 rounded-full"
              />
            </div>
            <div className="ml-5">Tara Ali</div>
            <div className="ml-10">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
                />
              </svg>
            </div>
          </div>
          {/*4*/}
          <div className="flex items-center  mb-4 shadow-md w-64 p-2 bg-white rounded-md">
            <div>
              <img
                src="https://source.unsplash.com/mEZ3PoFGs_k/400x400"
                alt="img"
                className="h-16 w-16 rounded-full"
              />
            </div>
            <div className="ml-5">Shara Raza</div>
            <div className="ml-10">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
                />
              </svg>
            </div>
          </div>
          {/*5*/}
          <div className="flex items-center  mb-4 shadow-md w-64 p-2 bg-white rounded-md">
            <div>
              <img
                src="https://source.unsplash.com/JN0SUcTOig0/400x400"
                alt="img"
                className="h-16 w-16 rounded-full"
              />
            </div>
            <div className="ml-5">Rasha Sarwa</div>
            <div className="ml-10">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
                />
              </svg>
            </div>
          </div>
          {/*6*/}
          <div className="flex items-center  mb-4 shadow-md w-64 p-2 bg-white rounded-md">
            <div>
              <img
                src="https://source.unsplash.com/hh3ViD0r0Rc/400x400"
                alt="img"
                className="h-16 w-16 rounded-full"
              />
            </div>
            <div className="ml-5">Hardi Salah</div>
            <div className="ml-10">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
                />
              </svg>
            </div>
          </div>
          {/*end6*/}
          {/*7*/}
          <div className="flex items-center  mb-4 shadow-md w-64 p-2 bg-white rounded-md">
            <div>
              <img
                src="https://images.unsplash.com/photo-1527565290982-018bcfdbee74?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=774&q=80"
                alt="img"
                className="h-16 w-16 rounded-full"
              />
            </div>
            <div className="ml-5">Nali Brwa</div>
            <div className="ml-10">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M12 6.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 12.75a.75.75 0 110-1.5.75.75 0 010 1.5zM12 18.75a.75.75 0 110-1.5.75.75 0 010 1.5z"
                />
              </svg>
            </div>
          </div>
          {/*end7*/}
        </div>

        {/*mails chats*/}
        <div className=" m-10 w-fit">
          {/*1*/}
          <div className="flex items-center  mb-4 shadow-md w-full p-2 bg-white rounded-md">
            <div>
              <img
                src="https://source.unsplash.com/JN0SUcTOig0/400x400"
                alt="img"
                className="h-16 w-16 rounded-full"
              />
            </div>
            <div className="ml-5">
              <p>Hello dear ,Hope you're fine?</p>
              <p>I need a FE Devloper ?!</p>{" "}
            </div>
          </div>
          {/*end1*/}
          {/*2*/}
          <div className="flex items-center  mb-4 shadow-md w-full p-2 bg-white rounded-md">
            <div className="mx-5">
              <p> I'm fine , How about you ?</p>
              <p>Yes sure , What's your requiements? </p>{" "}
            </div>
            <div>
              <img
                src="https://source.unsplash.com/ZHvM3XIOHoE/400x400"
                alt="img"
                className="h-16 w-16 rounded-full "
              />
            </div>
          </div>
          {/*end2*/}
          {/*1*/}
          <div className="flex items-center  mb-4 shadow-md w-full p-2 bg-white rounded-md">
            <div>
              <img
                src="https://source.unsplash.com/JN0SUcTOig0/400x400"
                alt="img"
                className="h-16 w-16 rounded-full"
              />
            </div>
            <div className="ml-5">
              <p>I need a food delivery application</p>
              <p>With a website also!</p>{" "}
            </div>
          </div>
          {/*end1*/}
          {/*2*/}
          <div className="flex items-center  mb-4 shadow-md w-full p-2 bg-white rounded-md">
            <div className="mx-5">
              <p> Do you have design template?</p>
            </div>
            <div>
              <img
                src="https://source.unsplash.com/ZHvM3XIOHoE/400x400"
                alt="img"
                className="h-16 w-16 rounded-full ml-8"
              />
            </div>
          </div>
          {/*end2*/}
          {/*1*/}
          <div className="flex items-center  mb-4 shadow-md w-full p-2 bg-white rounded-md">
            <div>
              <img
                src="https://source.unsplash.com/JN0SUcTOig0/400x400"
                alt="img"
                className="h-16 w-16 rounded-full"
              />
            </div>
            <div className="ml-5">
              <p>No , I also need a UX/UI Designer!</p>
            </div>
          </div>
          {/*end1*/}
          {/*2*/}
          <div className="flex items-center  mb-4 shadow-md w-full p-2 bg-white rounded-md">
            <div className="mx-5">
              <p> No worries ,</p>
              <p>I'm also a good UX/UI Designer.</p>
            </div>
            <div>
              <img
                src="https://source.unsplash.com/ZHvM3XIOHoE/400x400"
                alt="img"
                className="h-16 w-16 rounded-full ml-4"
              />
            </div>
          </div>
          {/*chat input*/}
          {/**/}
          <div className="flex items-center  mb-4 shadow-md w-full p-2 bg-white rounded-md">
            <div className="mr-2">
              <form className="container " action="/action_page.php">
                <input
                  className='bg-gray-100 w-72 text-gray-400 p-1 font-light text-sm rounded-md mb-3 mt-1  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-amber-400 focus:ring-white"'
                  type="text"
                  name="username"
                  id="username"
                  value="Enter your chat here.."
                />
              </form>
            </div>
            <div className="flex flex-cols justify-center items-center ">
              <div className="ml-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6.827 6.175A2.31 2.31 0 015.186 7.23c-.38.054-.757.112-1.134.175C2.999 7.58 2.25 8.507 2.25 9.574V18a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9.574c0-1.067-.75-1.994-1.802-2.169a47.865 47.865 0 00-1.134-.175 2.31 2.31 0 01-1.64-1.055l-.822-1.316a2.192 2.192 0 00-1.736-1.039 48.774 48.774 0 00-5.232 0 2.192 2.192 0 00-1.736 1.039l-.821 1.316z"
                  />
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M16.5 12.75a4.5 4.5 0 11-9 0 4.5 4.5 0 019 0zM18.75 10.5h.008v.008h-.008V10.5z"
                  />
                </svg>
              </div>
              <div className="ml-1">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M6 12L3.269 3.126A59.768 59.768 0 0121.485 12 59.77 59.77 0 013.27 20.876L5.999 12zm0 0h7.5"
                  />
                </svg>
              </div>
            </div>
          </div>
          {/*end chat input*/}
        </div>
      </div>
      <div className="flex justify-center items-end  ">
        <Link
          to="/contractmodal"
          className="shadow-md hover:shadow-lg m-0 bg-blue-900 hover:bg-blue-800 text-white px-3 py-2 rounded-lg text-sm font-semibold "
        >
          Make Contract
        </Link>
      </div>
    </div>
  );
}
